export default "__VITE_ASSET__B6C7P6xW__"